import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import { BookingDefectSchema, ExternalAPIErrorSchema, NotFoundErrorSchema, ConsultTimesNotFoundErrorSchema } from "./errors";
import { AppointmentTypeList, AppointmentTypePolicySettingsResponse } from "./appointment-type.schema";
import { TimeSlotList } from "./time-slot.schema";
import { BookingStatusRequestSchema, BookingStatusResponseSchema, BookingRecoveryErrorSchema } from "./booking-recovery.schema";
const GetAppointmentTypesRequestSchema = Schema.Struct({ calendarId: Schema.optional(Schema.String) });
const GetAppointmentTypePoliciesRequestSchema = Schema.Struct({});
const GetAvailableTimeSlotsRequestSchema = Schema.Struct({ appointmentTypeId: Schema.String, startDate: Schema.String, endDate: Schema.String });
/** Client-safe scheduling RPC operations, composed once into the bridge aggregate.
 * @since 1.1.8
 * @example FrontDeskSchedulingRpcs.requests.has("FrontDeskGetBookingStatus");
 */
export class FrontDeskSchedulingRpcs extends RpcGroup.make(
  Rpc.make("FrontDeskGetBookingStatus", {
    defect: BookingDefectSchema,
    success: BookingStatusResponseSchema,
    error: BookingRecoveryErrorSchema,
    payload: BookingStatusRequestSchema,
  }),
  // Scheduling
  Rpc.make("FrontDeskGetAppointmentTypes", {
    success: AppointmentTypeList,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: GetAppointmentTypesRequestSchema,
  }),

  Rpc.make("FrontDeskGetAppointmentTypePolicies", {
    success: AppointmentTypePolicySettingsResponse,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: GetAppointmentTypePoliciesRequestSchema,
  }),

  Rpc.make("FrontDeskGetAvailableTimeSlots", {
    success: TimeSlotList,
    error: Schema.Union(
      [ExternalAPIErrorSchema,
      NotFoundErrorSchema,
      ConsultTimesNotFoundErrorSchema],
    ),
    payload: GetAvailableTimeSlotsRequestSchema,
  }),

) {}
